import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { AiAgentSelect } from "@/react/components/shared/uikit/AiAgentSelect";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { Form } from "@circle-react-uikit/Form";
import { useCurrentAction } from "../../../ActionRule";
import { useDefaultValueForField } from "../../../useDefaultValueforField";
import { useIsAiAutomationsV2Enabled } from "../renamePostTitle/useIsAiAutomationsV2Enabled";

export const FormHidePostFromFeaturedAreas = () => {
  const { paramsPath } = useCurrentAction();

  const { setValue, getValues } = useFormContext();

  const isAiAutomationV2Enabled = useIsAiAutomationsV2Enabled();

  const selectedId = getValues(`${paramsPath}.community_bot_profile_id`) as
    | number
    | null;

  useDefaultValueForField(`${paramsPath}.community_bot_profile_id`, null);
  useDefaultValueForField(`${paramsPath}.close_comments`, false);
  useDefaultValueForField(`${paramsPath}.hide_metadata`, false);
  useDefaultValueForField(
    `${paramsPath}.hide_post_from_featured_areas`,
    isAiAutomationV2Enabled ? false : true,
  );

  return (
    <div className="flex flex-col gap-9">
      {!isAiAutomationV2Enabled && (
        <Form.Item
          name={`${paramsPath}.community_bot_profile_id`}
          hideBorder
          fullWidth
          hideDescription
          label={t("settings.workflows.form.agent")}
          labelClassName="!mb-2 !text-sm"
          className="!py-0"
        >
          <AiAgentSelect
            selectedId={selectedId}
            setValue={(value: number) =>
              setValue(`${paramsPath}.community_bot_profile_id`, value)
            }
            placeholderKey="settings.workflows.form.select_agent"
            notFoundKey="settings.workflows.form.no_agents_found"
            enabledStatus
          />
        </Form.Item>
      )}

      {isAiAutomationV2Enabled && (
        <div className="flex flex-col gap-4">
          <div className="mb-1">
            <Typography.LabelSm weight="semibold">
              {t("settings.workflows.form.what_do_you_want_to_do")}
            </Typography.LabelSm>
          </div>
          <Form.Item
            name={`${paramsPath}.close_comments`}
            hideBorder
            fullWidth
            hideDescription
            hideLabel
            className="!py-0"
            rules={{
              required: false,
            }}
          >
            <div className="flex items-center">
              <span className="mr-4">
                <Form.ToggleSwitch
                  variant="small"
                  name={`${paramsPath}.close_comments`}
                  onChange={e =>
                    setValue(`${paramsPath}.close_comments`, e.target.value)
                  }
                />
              </span>
              <Typography.LabelSm weight="semibold">
                {t("settings.workflows.form.close_comments")}
              </Typography.LabelSm>
            </div>
          </Form.Item>
          <Form.Item
            name={`${paramsPath}.hide_post_from_featured_areas`}
            hideBorder
            fullWidth
            hideDescription
            hideLabel
            className="!py-0"
            rules={{
              required: false,
            }}
          >
            <div className="flex items-center">
              <span className="mr-4">
                <Form.ToggleSwitch
                  variant="small"
                  name={`${paramsPath}.hide_post_from_featured_areas`}
                  onChange={e =>
                    setValue(
                      `${paramsPath}.hide_post_from_featured_areas`,
                      e.target.value,
                    )
                  }
                />
              </span>
              <Typography.LabelSm weight="semibold">
                {t("settings.workflows.form.hide_post_from_featured_areas")}
              </Typography.LabelSm>
            </div>
          </Form.Item>

          <Form.Item
            name={`${paramsPath}.hide_metadata`}
            hideBorder
            fullWidth
            hideDescription
            hideLabel
            className="!py-0"
            rules={{
              required: false,
            }}
          >
            <div className="flex items-center">
              <span className="mr-4">
                <Form.ToggleSwitch
                  variant="small"
                  name={`${paramsPath}.hide_metadata`}
                  onChange={e =>
                    setValue(`${paramsPath}.hide_metadata`, e.target.value)
                  }
                />
              </span>
              <Typography.LabelSm weight="semibold">
                {t("settings.workflows.form.hide_metadata")}
              </Typography.LabelSm>
            </div>
          </Form.Item>
        </div>
      )}
    </div>
  );
};
